/**
 * Type guard for ActionModel
 */
export function isActionModel(actions) {
  return Array.isArray(actions) && !!actions.length && 'Name' in actions[0];
}

/**
 * Type guard to check if the setting is a CurrencyFieldSetting
 * @param {FieldSetting} fieldSetting
 * @returns {fieldSetting is CurrencyFieldSetting}
 */
export function isCurrencyFieldSetting(fieldSetting) {
  return Object.prototype.hasOwnProperty.call(fieldSetting, 'Format') || fieldSetting.Type === 'CurrencyFieldSetting';
}
//# sourceMappingURL=type-guards.js.map